import { useContext } from 'react';
import type * as React from 'react';
import { CardContext } from '../../utils/cardContext';
import { Description as DescriptionComponent } from '../../components/Building/parts/Description';

export const Description = (): React.JSX.Element => {
  const { description } = useContext(CardContext);

  return <DescriptionComponent text={description} />;
};
